import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

function SearchDropDown({
	value,
	dropDownData,
	onChange,
	placeholder,
	error,
	onHandleBlur,
	disable = false,
	placeholderTxt = 'No options',
}) {
	return (
		<Autocomplete
			size="small"
			sx={{ width: '100%', backgroundColor: '#FFFFFF', fontSize: '14px' }}
			value={value}
			options={dropDownData}
			onBlur={onHandleBlur}
			onChange={onChange}
			disableClearable={true}
			disabled={disable}
			noOptionsText={placeholderTxt}
			renderInput={({ inputProps, ...params }) => (
				<TextField
					placeholder={placeholder}
					error={error}
					inputProps={{
						...inputProps,
						readOnly: true,
						style: { fontSize: '14px' },
					}}
					{...params}
				/>
			)}
			isOptionEqualToValue={(option, value) => option === value}
			renderOption={(props, option, { selected }) => (
				<li {...props} key={props.id} style={{ fontSize: '14px' }}>
					{option}
				</li>
			)}
		/>
	);
}

export default SearchDropDown;
